import React from "react";
import style from "./Paginacao.module.css";
import { LiaAngleLeftSolid, LiaAngleRightSolid } from "react-icons/lia";

function Paginacao({ paginaAtual, totalPages = 1, onPageChange }) {
  const totalPaginasCorrigido = Math.max(totalPages, 1); // Garante que seja no mínimo 1

  return (
    <div className={style.pagination}>
      <button
        onClick={() => onPageChange(paginaAtual - 1)}
        disabled={paginaAtual === 1}
      >
        <LiaAngleLeftSolid />
      </button>
      <span>
        Página {paginaAtual} de {totalPaginasCorrigido}
      </span>
      <button
        onClick={() => onPageChange(paginaAtual + 1)}
        disabled={paginaAtual === totalPaginasCorrigido}
      >
        <LiaAngleRightSolid />
      </button>
    </div>
  );
}

export default Paginacao;